query AnalyticsSalesByLink($filter: AnalyticsSalesFilterInput!, $limit: Int) {
  analyticsSales(filter: $filter) {
    currency
    salesByLink(limit: $limit) {
      linkId
      title
      sales
      revenue
      reward
    }
  }
}
